import type { Layer, ApiType } from '../global/constants/layers';

export interface UnifiedLayerConfig {
  png32: number;
  name: string;
  id: number;
  api: ApiType;
}

export function flattenLeaves(tree: Layer[]): UnifiedLayerConfig[] {
  return tree.flatMap((node) => {
    if (node.children) {
      return flattenLeaves(node.children);
    }
    if (node.id == null || node.api == null) return [];
    return [
      { name: node.title, id: node.id, api: node.api, png32: node.png32 ?? 0 },
    ];
  });
}
